<div class="side-nav-container">
  <ng-container *authGroup="currentRoles">
    <ng-container *authGroup="dashboard.access">
      <a
        class="side-nav-top-link"
        [routerLink]="dashboard.route"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="active"
      >
        <mat-icon>{{ dashboard.icon }}</mat-icon>
        <span>{{ dashboard.label }}</span>
      </a>
    </ng-container>

    <mat-nav-list>
      <mat-expansion-panel [hideToggle]="!stocktake.expanded" (opened)="stocktake.expanded=true"
        (closed)="stocktake.expanded=false" *authGroup="stocktake.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>history_edu</mat-icon>
            <span>{{stocktake.label}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of stocktake.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>

      <!-- <mat-list-item [routerLink]="stocktake.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
      *authGroup="stocktake.access">
      <mat-icon mat-list-icon>history_edu</mat-icon>
      <a mat-line>{{stocktake.label}}</a>
    </mat-list-item> -->

    <mat-accordion class="example-headers-align">

      <mat-expansion-panel [hideToggle]="!prescription.expanded" (opened)="prescription.expanded=true"
        (closed)="prescription.expanded=false" *authGroup="prescription.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>library_books</mat-icon>
            <span>Prescriptions</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of prescription.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-expansion-panel [hideToggle]="!batch.expanded" (opened)="batch.expanded=true"
        (closed)="batch.expanded=false" *authGroup="batch.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>layers</mat-icon>
            <span>Batches</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of batch.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-divider *authGroup="individual.access"></mat-divider>


      <mat-expansion-panel [hideToggle]="!individual.expanded" (opened)="individual.expanded=true"
        (closed)="individual.expanded=false" *authGroup="individual.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>people</mat-icon>
            <span>Individuals</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of individual.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-expansion-panel [hideToggle]="!company.expanded" (opened)="company.expanded=true"
        (closed)="company.expanded=false" *authGroup="company.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>business</mat-icon>
            <span>Companies</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of company.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-expansion-panel [hideToggle]="!medicine.expanded" (opened)="medicine.expanded=true"
        (closed)="medicine.expanded=false" *authGroup="medicine.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>medication</mat-icon>
            <span>Medicine</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of medicine.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>

      <mat-expansion-panel [hideToggle]="!ordermedicine.expanded" (opened)="ordermedicine.expanded=true"
        (closed)="ordermedicine.expanded=false" *authGroup="ordermedicine.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>medication</mat-icon>
            <span>Order System</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of ordermedicine.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matListItemLine>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>

    <mat-divider *authGroup="systemManagement.access"></mat-divider>

    <mat-expansion-panel [hideToggle]="!systemManagement.expanded" (opened)="systemManagement.expanded=true"
      (closed)="systemManagement.expanded=false" *authGroup="systemManagement.access">
      <mat-expansion-panel-header>
        <mat-panel-title class="side-nav-panel-title">
          <mat-icon>tune</mat-icon>
          <span>System management</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (link of systemManagement.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
          *authGroup="link.access">
          <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
          <span matListItemLine>{{link.label}}</span>
        </mat-list-item>
      }
    </mat-expansion-panel>

    <mat-expansion-panel [hideToggle]="!user.expanded" (opened)="user.expanded=true" (closed)="user.expanded=false"
      *authGroup="user.access">
      <mat-expansion-panel-header>
        <mat-panel-title class="side-nav-panel-title">
          <mat-icon>people</mat-icon>
          <span>User management</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (link of user.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
          *authGroup="link.access">
          <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
          <span matListItemLine>{{link.label}}</span>
        </mat-list-item>
      }
    </mat-expansion-panel>

    @if (sageUiEnabled) {
      <mat-expansion-panel [hideToggle]="!sage.expanded" (opened)="sage.expanded=true" (closed)="sage.expanded=false"
        *authGroup="sage.access">
        <mat-expansion-panel-header>
          <mat-panel-title class="side-nav-panel-title">
            <mat-icon>sync_alt</mat-icon>
            <span>{{ sage.label }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of sage.links; track link) {
        <mat-list-item class="side-nav-item" [routerLink]="link.route" [routerLinkActiveOptions]="{exact: false}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon matListItemIcon>{{ link.icon }}</mat-icon>
            <span matListItemLine>{{ link.label }}</span>
          </mat-list-item>
        }
      </mat-expansion-panel>
    }

  </mat-accordion>
    </mat-nav-list>
  </ng-container>
</div>
